import { Tab, TabProps } from "@mui/material";
import { forwardRef } from "react";
import styles from "./styles.module.css";

interface Props extends TabProps {
  className?: string;
}

export const AppTab = forwardRef<React.ElementRef<typeof Tab>, Props>(
  ({ className, ...rest }: Props, ref) => {
    return <Tab ref={ref} className={className} {...rest} />;
  },
);
